import { render, staticRenderFns } from "./TrafficTable.vue?vue&type=template&id=33848ca0&"
import script from "./TrafficTable.vue?vue&type=script&lang=js&"
export * from "./TrafficTable.vue?vue&type=script&lang=js&"
import style0 from "./TrafficTable.vue?vue&type=style&index=0&id=33848ca0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports